import { OnInit, Input, Output, Component, EventEmitter } from '@angular/core';
import { LoaderService } from '../../../infrastructure/services/loader.service';
import {ItemComboBox} from '../itemClasses/itemComboBox.class';
import { audit } from 'rxjs/operator/audit';

@Component({
    selector: 'sx-combo-box',
    templateUrl: './comboBox.component.html',
    styleUrls: ['./formWidgets.css'],
  })
  export class ComboBoxComponent implements OnInit {
    // Texto inicial
    @Input() itemSeleccionado: string;
    @Input() deshabilitado: string;
    @Input() items: string[]; 
  
    // Evento cuando el usuario acepta el cambio del texto
    @Output() itemCambiado: EventEmitter<string> = new EventEmitter();
    
    itemLocal: string;
    editando = false;
    error: string = null;
    itemsDelComboBox: ItemComboBox[] = [];
    //tablaDeSeleccion: Boolean[] = [];
    
  
    ngOnInit() { 
      this.itemLocal = this.itemSeleccionado;
      this.ActualizarItemsComboBox();
    }
  
    confirmarEdicion() {
      if (!this.validarDescripcionExt(this.itemLocal)) 
      {
        this.ActualizarItemsComboBox();
        return;
      }
  
      this.itemCambiado.emit(this.itemLocal);
      this.itemSeleccionado = this.itemLocal;
      this.ActualizarItemsComboBox();
      this.editando = false;
      this.error = null;     
    }
  
    deshacerEdicion() 
    {
      this.ActualizarItemsComboBox();
      this.itemLocal = this.itemSeleccionado;
      this.editando = false;
      this.error = null;
    }
  

    private validarDescripcionExt(valor: string, error?: string) 
    {
      return true;
    };


    private ActualizarItemsComboBox()
    {
      if(this.itemsDelComboBox.length === 0)
      {
        this.items.forEach(element =>
          {

            var aux = new ItemComboBox();
                aux.Index = element;
                aux.Descripcion = element;
                aux.Seleccionado = (element === this.itemSeleccionado);
            this.itemsDelComboBox.push(aux);
          }
        );   
      }
      else
      {
        this.itemsDelComboBox.forEach(element => 
          {
            element.Seleccionado = (element.Index === this.itemSeleccionado); 
          });
      }
    }
  }



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/formWidgets/comboBox.component.ts